import React from "react";

const ChooseLead = () => {
  return <div>choose leade</div>;
};

export default ChooseLead;
